export const externalUrl = {
  flaskServiceUrl: 'https://csdiagnostic.voltup.in:8083'
}
